// @flow
import { ActivitiesActionTypes } from './constants';

type ActivitiesAction = { type: string, payload: {} | string };

// common success
export const activitiesApiResponseSuccess = (actionType: string, data: any): ActivitiesAction => ({
    type: ActivitiesActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const activitiesApiResponseError = (actionType: string, error: string): ActivitiesAction => ({
    type: ActivitiesActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getActivity = (id: string): ActivitiesAction => ({
    type: ActivitiesActionTypes.GET_ACTIVITY,
    payload: { id },
});

export const addActivity = (activity: any): ActivitiesAction => ({
    type: ActivitiesActionTypes.ADD_ACTIVITY,
    payload: activity
})
export const updateActivity = (activity: any): ActivitiesAction => ({
    type: ActivitiesActionTypes.UPDATE_ACTIVITY,
    payload: activity
})
export const deleteActivity = (id: string): ActivitiesAction => ({
    type: ActivitiesActionTypes.DELETE_ACTIVITY,
    payload: { id }
})

export const listActivities = (params: any): ActivitiesAction => ({
    type: ActivitiesActionTypes.LIST_ACTIVITIES,
    payload: params,
});


export const resetActivities = (): ActivitiesAction => ({
    type: ActivitiesActionTypes.RESET,
    payload: {},
});

